import moment from 'moment-timezone'

export const getCurrentDate = (timezone: string) => {
  return moment.tz(timezone).format()
}

/** Start of the default range: last 7 inclusive calendar days ending today (today − 6). */
export const getWeekAgoDate = (timezone: string) => {
  return moment.tz(timezone).subtract(6, 'days').format()
}
